import { Button, Card, CardContent, CardHeader, CardTitle } from '@sunstone/ui';
import { Database, Layers } from 'lucide-react';
import { EmptyState } from '@/components/ui/EmptyState';
import { PageHeader } from '@/components/ui/PageHeader';

export function InfrastructurePage() {
  return (
    <div className="space-y-8">
      <PageHeader
        title="Infrastructure"
        description="Provision and manage cloud resources like Kubernetes clusters and databases."
        action={<Button disabled>New Resource</Button>}
      />

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-2">
        <Card className="hover:shadow-md transition-shadow">
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Layers className="w-5 h-5 text-blue-500" />
              Kubernetes Clusters
            </CardTitle>
          </CardHeader>
          <CardContent>
            <EmptyState
              icon={<Layers className="w-8 h-8 text-muted-foreground/50" />}
              title="No clusters found"
              description="Provision a new Kubernetes cluster to start deploying your applications."
              actionLabel="Create Cluster"
            />
          </CardContent>
        </Card>

        <Card className="hover:shadow-md transition-shadow">
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Database className="w-5 h-5 text-green-500" />
              Databases
            </CardTitle>
          </CardHeader>
          <CardContent>
            <EmptyState
              icon={<Database className="w-8 h-8 text-muted-foreground/50" />}
              title="No databases found"
              description="Create a managed database instance for your application data."
              actionLabel="Create Database"
            />
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
